import styled from '@emotion/styled'

import { ComponentsGroup } from '../ComponentsGroup'

export const RadioGroupWrapper = styled(ComponentsGroup)``
